import MediaLibraryTabs from './MediaLibraryTabs';

export default MediaLibraryTabs;
